module.exports = __webpack_public_path__ + "img/iOS-action.57505a22.svg";